<ng-container *ngIf="src">
  <iframe [src]="src | sanitizerUrl:'url'" appIframeTrackerDirective></iframe>
</ng-container>
